import { useMemo, useState } from 'react';
import { shouldShowTicketInModal } from '../utils/ticketHelper';

const useTicketListVisibility = ({ tickets, role, startTime }) => {
    const [hideUnavailable, setHideUnavailable] = useState(true);
    const [showLongExpired, setShowLongExpired] = useState(false);

    const visibleTickets = useMemo(() => {
        return [...tickets]
            .sort((a, b) => a?.ticket_order - b?.ticket_order)
            .filter(ticket =>
                shouldShowTicketInModal({
                    ticket,
                    role,
                    startTime,
                    hideUnavailable,
                    showLongExpired
                })
            );
    }, [tickets, role, startTime, hideUnavailable, showLongExpired]);

    return {
        hideUnavailable,
        setHideUnavailable,
        showLongExpired,
        setShowLongExpired,
        visibleTickets
    };
};

export default useTicketListVisibility;
